import { render, staticRenderFns } from "./detailKegiatanBimtek.vue?vue&type=template&id=2c064d08&scoped=true"
import script from "./detailKegiatanBimtek.vue?vue&type=script&lang=js"
export * from "./detailKegiatanBimtek.vue?vue&type=script&lang=js"
import style0 from "./detailKegiatanBimtek.vue?vue&type=style&index=0&id=2c064d08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c064d08",
  null
  
)

export default component.exports